// Small CSS-class-by-status lookups shared across the Delivery pages,
// same convention as purchases/status-styles.ts.

export function validationStatusClass(status: string): string {
  switch (status) {
    case 'VALIDATED':
      return 'bg-green-100 text-green-800';
    case 'DISCREPANCY':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-700';
  }
}

export function returnStatusClass(status: string): string {
  switch (status) {
    case 'COMPLETED':
      return 'bg-green-100 text-green-800';
    case 'RECEIVED':
      return 'bg-blue-100 text-blue-800';
    case 'REJECTED':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-amber-100 text-amber-800';
  }
}

export function conditionClass(condition: string | null): string {
  switch (condition) {
    case 'DAMAGED':
      return 'bg-red-100 text-red-800';
    case 'UNSELLABLE':
      return 'bg-red-100 text-red-800';
    case 'GOOD':
      return 'bg-green-100 text-green-800';
    default:
      return 'bg-gray-100 text-gray-700';
  }
}
